const homeRouteBase = {
  name: 'navLinks.home',
  showInMobileNav: false,
  showInHeader: true,
  type: 'game',
  positionMenu: 1,
  positionNavMob: 10,
}
const homeRoute = process.env.OWN_SPORT
  ? {
      ...homeRouteBase,
      name: 'navLinks.homeCasino',
      routeParams: { name: 'Home' },
    }
  : {
      ...homeRouteBase,
      routeParams: { name: 'Home' },
    }

const sportRouteBase = {
  name: 'navLinks.sport',
  group: '',
  mobileImg: 'ball-of-basketball',
  showInMobileNav: true,
  showInHeader: true,
  type: 'games',
  positionMenu: 15,
  positionNavMob: 6,
}

const sportRouteOwn = {
  name: 'navLinks.sport',
  group: '',
  mobileImg: 'ball-of-basketball',
  showInMobileNav: true,
  showInHeader: true,
  type: 'games',
  positionMenu: 1,
  positionNavMob: 2,
}
const sportRoute = process.env.OWN_SPORT
  ? {
      ...sportRouteOwn,
      routeParams: { name: 'new-sport' },
    }
  : {
      ...sportRouteBase,
      href: '/',
    }
let categoriesFn
if (process.env.PLATFORM === 'olimp') {
  categoriesFn = require('./olimp.js').default
} else if (process.env.PLATFORM === 'olymp') {
  categoriesFn = require('./olymp.js').default
}

export default {
  namespace: true,
  state: () => ({
    categories: categoriesFn(homeRoute, sportRoute),
  }),
  getters: {
    getCategories: (s) => s.categories,
  },
}
